export const UPDATE_QUICK_COMPARE_OFFER = 'UPDATE_QUICK_COMPARE_OFFER';
